import {
  GET_VENDORRESULT_BEGIN,
  GET_VENDORRESULT_SUCCESS,
  GET_VENDORRESULT_FAIL
} from '../action/vendorresultAction'

const initialState = {
  loading: false,
  vendorresults: null,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_VENDORRESULT_BEGIN:
      return {
        loading: true,
        error: null
      }
    case GET_VENDORRESULT_SUCCESS:
      return {
        loading: false,
        vendorresults: action.payload.data
      }
    case GET_VENDORRESULT_BEGIN:
      return {
        loading: false,
        error: action.payload.error
      } 
    default:
      return state
  }
}